import { Component, OnInit, Optional, Inject, ViewChild } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, tap, takeUntil } from "rxjs/operators";
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { of as observableOf, Subscription, fromEvent } from 'rxjs';
import { LanguageService, DialogService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-pricelist-download-filter',
  templateUrl: './pricelist-download-filter.component.html',
  styleUrls: ['./pricelist-download-filter.component.scss']
})
export class PricelistDownloadFilterComponent implements OnInit {
  @ViewChild('chainAC') chainACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) chainACTr: MatAutocompleteTrigger;
  @ViewChild('branchAC') branchACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) branchACTr: MatAutocompleteTrigger;
  @ViewChild('categoryAC') categoryACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) categoryACTr: MatAutocompleteTrigger;
  @ViewChild('brandAC') brandACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) brandACTr: MatAutocompleteTrigger;
  @ViewChild('itemAC') itemACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) itemACTr: MatAutocompleteTrigger;

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public dialogRef: MatDialogRef<PricelistDownloadFilterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public loading = {
    chain: false,
    branch: false,
    category: false,
    brand: false,
    item: false,
    status: false,
    error: false
  };

  private getDataSub: Subscription;
  public defaultOption = {
    code: "all",
    description: "All"
  };

  chains = [];
  branches = [];
  categorys = [];
  brands = [];
  items = [];
  statuses = [
    {
      code: "1",
      description: "Active",
    },
    {
      code: "0",
      description: "Inactive",
    },
  ];
  options = [
    {
      code: "0",
      description: "All",
    },
    {
      code: "2",
      description: "With Override Price",
    },
    {
      code: "1",
      description: "Without Override Price",
    },
  ];
  public filters;

  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {});

  ngOnInit() {
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }

  initForm() {
    this.formGroup = this.fb.group({
      chain: [_.get(this.data, 'chain'), Validators.required],
      branch: [_.get(this.data, 'branch') || this.options[0]],
      category: [_.get(this.data, 'category') || this.options[0]],
      brand: [_.get(this.data, 'brand') || this.options[0]],
      item: [_.get(this.data, 'item') || this.options[0]],
      option: [_.get(this.data, 'option') || this.options[0], Validators.required],
      from_effectivity_start_date: [_.get(this.data, 'from_effectivity_start_date')],
      to_effectivity_start_date: [_.get(this.data, 'to_effectivity_start_date')],
      from_effectivity_end_date: [_.get(this.data, 'from_effectivity_end_date')],
      to_effectivity_end_date: [_.get(this.data, 'to_effectivity_end_date')],
      status: [_.get(this.data, 'status') || this.statuses[0], Validators.required]
    })

    if (_.get(this.data, 'option.code') == "1") {
     ​this.formGroup.get('from_effectivity_start_date').disable()
      this.formGroup.get('to_effectivity_start_date').disable();
      this.formGroup.get('from_effectivity_end_date').disable();
      this.formGroup.get('to_effectivity_end_date').disable();
    }
    else {
      this.formGroup.get('from_effectivity_start_date').enable();
      this.formGroup.get('to_effectivity_start_date').enable();
      this.formGroup.get('from_effectivity_end_date').enable();
      this.formGroup.get('to_effectivity_end_date').enable();
    }      
  }

  compareWithFunc = (a: any, b: any) => (a && b) ? a.code == b.code : null;

  detectFormChanges() {
    this.formGroup.get('option').valueChanges.subscribe(value => {
      this.formGroup.get('from_effectivity_start_date').reset();
      this.formGroup.get('to_effectivity_start_date').reset();
      this.formGroup.get('from_effectivity_end_date').reset();
      this.formGroup.get('to_effectivity_end_date').reset();

      if (_.get(value, 'code') == "1") {
        this.formGroup.get('from_effectivity_start_date').disable();
        this.formGroup.get('to_effectivity_start_date').disable();
        this.formGroup.get('from_effectivity_end_date').disable();
        this.formGroup.get('to_effectivity_end_date').disable();
      }
      else {
        this.formGroup.get('from_effectivity_start_date').enable();
        this.formGroup.get('to_effectivity_start_date').enable();
        this.formGroup.get('from_effectivity_end_date').enable();
        this.formGroup.get('to_effectivity_end_date').enable();
      }
    });
 
    this.formGroup.get("chain").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.chains = [];
      this.getData("chain");
    });
 
    this.formGroup.get("branch").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.branches = [];
      this.getData("branch");
    });
     
    this.formGroup.get("category").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.categorys = [];
      this.getData("category");
    });
 
    this.formGroup.get("brand").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.brands = [];
      this.getData("brand");
    });
 
    this.formGroup.get("item").valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.filters.web_filter.keyword = _.toString(value);
      this.items = [];
      this.getData("item");
    });
  }

  getInitialData(name) {
    this.autoCmpltClosed(name);
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.getData(name);
  }
 
  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }
 
  getData(name) {
    let filters = _.cloneDeep(this.filters)
    this.filters.getMore = false;
    this.loading[name] = true;
 
    switch (name) {
      case "chain": {
        filters.web_filter["chain_type_ids"] = [0];
 
        this.campSvc.getChains(filters).pipe(
          tap(() => this.loading.chain = true),
          finalize(() => {
            this.loading.chain = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.chain = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.chain = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.chains = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.chains = this.chains.concat(res.data);
             
              if((res.data.length > 0) && (this.chains.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "branch": {
        filters.web_filter["chain_ids"] = [_.get(this.formGroup.get('chain'), 'value.id') || 0];
 
        this.campSvc.getBranches(filters).pipe(
          tap(() => this.loading.branch = true),
          finalize(() => {
            this.loading.branch = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.branch = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.branch = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.branches = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.branches[0] = this.defaultOption;
              }
              this.branches = this.branches.concat(res.data);
          
              if((res.data.length > 0) && (this.branches.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }

      case "category": {
        filters.web_filter["branch_ids"] = [_.get(this.formGroup.get('branch'), 'value.id') || 0];

        this.campSvc.getCategories(filters).pipe(
          tap(() => this.loading.category = true),
          finalize(() => {
            this.loading.category = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.category = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.category = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.categorys = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.categorys[0] = this.defaultOption;
              }
              this.categorys = this.categorys.concat(res.data);

              if((res.data.length > 0) && (this.categorys.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "brand": {
        filters.web_filter["category_ids"] = [_.get(this.formGroup.get('category'), 'value.id') || 0];
 
        this.campSvc.getBrands(filters).pipe(
          tap(() => this.loading.brand = true),
          finalize(() => {
            this.loading.brand = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.brand = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.brand = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.brands = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.brands[0] = this.defaultOption;
              }
              this.brands = this.brands.concat(res.data);
      
              if((res.data.length > 0) && (this.brands.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
      
      case "item": {
        filters.web_filter["category_ids"] = [_.get(this.formGroup.get('category'), 'value.id') || 0];
        filters.web_filter["brand_ids"] = [_.get(this.formGroup.get('brand'), 'value.id') || 0];
 
        this.campSvc.getItems(filters).pipe(
          tap(() => this.loading.item = true),
          finalize(() => {
            this.loading.item = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.item = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.item = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;
              this.items = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.items[0] = this.defaultOption;
              }
              this.items = this.items.concat(res.data);
          
              if((res.data.length > 0) && (this.items.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }
    }
  }

  autoCmpltClosed(name) {
    let options = (name != 'branch' || name != 'status') ? (name + "s") : (name + "es");
    this[options] = [];
  }

  resetControl(control: FormControl) {
    control.reset(null, { emitEvent: false });
  }
 
  displayFn(data?: any): string | undefined {
    return _.get(data, 'description');
  }
 
  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }

  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if(!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }

    if(this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value);
    }
  }

  clearDates(fromCtrl, toCtrl) {
    // handles toggling mat-datepicker issue
    if(!this.formGroup.get('chain').value) {
      this.formGroup.get('chain').reset(null, {emitEvent: false});
      this.formGroup.get('chain').markAsUntouched();
    }
    if(!this.formGroup.get('option').value) {
      this.formGroup.get('option').reset(null, {emitEvent: false});
      this.formGroup.get('option').markAsUntouched();
    }
    if(fromCtrl == 'from_effectivity_start_date' && !this.formGroup.get('from_effectivity_end_date').value) {
      this.formGroup.get('from_effectivity_end_date').reset(null, {emitEvent: false});
      this.formGroup.get('from_effectivity_end_date').markAsUntouched();
    }
    if(toCtrl == 'to_effectivity_start_date' && !this.formGroup.get('to_effectivity_end_date').value) {
      this.formGroup.get('to_effectivity_end_date').reset(null, {emitEvent: false});
      this.formGroup.get('to_effectivity_end_date').markAsUntouched();
    }
    if(fromCtrl == 'from_effectivity_end_date' && !this.formGroup.get('from_effectivity_start_date').value) {
      this.formGroup.get('from_effectivity_start_date').reset(null, {emitEvent: false});
      this.formGroup.get('from_effectivity_start_date').markAsUntouched();
    }
    if(toCtrl == 'to_effectivity_end_date' && !this.formGroup.get('to_effectivity_start_date').value) {
      this.formGroup.get('to_effectivity_start_date').reset(null, {emitEvent: false});
      this.formGroup.get('to_effectivity_start_date').markAsUntouched();
    }

    this.formGroup.get(fromCtrl).reset(null, {emitEvent: false});
    this.formGroup.get(toCtrl).reset(null, {emitEvent: false});
    this.formGroup.get(fromCtrl).markAsUntouched();
    this.formGroup.get(toCtrl).markAsUntouched();
  }

  areDatesRequired(fromCtrl, toCtrl) {
    if(_.get(this.formGroup.get('option'), 'value.code') == '0' || _.get(this.formGroup.get('option'), 'value.code') == '2') {
      if((this.formGroup.get(fromCtrl).value && this.formGroup.get(toCtrl).value)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  reset() {
    for(let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, {emitEvent: false});
      this.formGroup.controls[ctrl].setValue(null, {emitEvent: false});
      this.formGroup.controls[ctrl].markAsUntouched();
    }
    this.formGroup.get('branch').setValue(this.defaultOption);
    this.formGroup.get('category').setValue(this.defaultOption);
    this.formGroup.get('brand').setValue(this.defaultOption);
    this.formGroup.get('item').setValue(this.defaultOption);
    this.formGroup.get('option').setValue(this.options[0]);
    this.formGroup.get('status').setValue(this.statuses[0]);
  }
}

const INITIAL_OPTIONS = {
	web_filter: {
		limit: 50,
		offset: 0,
    keyword: "",
    order_by: "asc",
    is_asc: 1,
    chain_ids: [0],
    chain_type_ids: [0],
    region_ids:[0],
    province_ids: [0],
    city_ids:[0],
    status: null
	}
}